module.exports = __webpack_public_path__ + "images/category_lp/pc/PC1_24b3132de597c73ed89f32dd563df844.png";